import OwnImage from "@ui/components/ui/event/OwnImage";

export function ForgotPasswordConfirmation() {
  return (
    <>
      <div className="flex flex-col items-center gap-2">
        <OwnImage
          src="/images/logos/logo_connect_events_vertical.png"
          alt="logo avec nom Connect'Events vertical"
          className="static h-28 w-auto"
        />
      </div>
      <div className="text-center">
        <h1 className="text-xl font-extrabold text-black">
          Réinitialisation du mot de passe
        </h1>
        <p className="text-center text-sm text-black">
          Un email de réinitialisation de mot de passe vous a été envoyé
        </p>
      </div>
    </>
  );
}

export default ForgotPasswordConfirmation;
